import React, { FunctionComponent, useEffect, useRef } from 'react'
import * as S from './styled'
import { Period } from '../../../pages/DashBoard/DashBoardScreen'
import moment from 'moment'
import { ReactComponent as DeleteIcon } from './delete-icon.svg'
import { Filter } from '../../../redux/requests/products/product.types'

type OwnProps = {
  caption?: string
  unit: Period
  selected: boolean
  showCalender: boolean
  startDate: Date
  endDate: Date
  clickHandler: any
  index: number
  id: string
  setLineX: React.Dispatch<React.SetStateAction<number>>
  setOffset: React.Dispatch<React.SetStateAction<number>>
  isFirst: boolean
  setCustomFilters: React.Dispatch<React.SetStateAction<Filter[]>>
  setSelectedOpt: React.Dispatch<React.SetStateAction<number>>
  deleteFilter: (filterId: string) => void
}

type Props = OwnProps

export const TimePeriod: FunctionComponent<Props> = ({
  caption,
  unit,
  selected,
  startDate,
  endDate,
  clickHandler,
  index,
  id,
  isFirst,
  setLineX,
  setOffset,
  deleteFilter,
}) => {
  const xRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    selected && setLineX(xRef?.current?.offsetLeft!)
    isFirst && setOffset(xRef?.current?.offsetLeft!)
  }, [xRef.current?.offsetLeft])
  return (
    <>
      <S.Card
        ref={xRef}
        onClick={() => {
          return clickHandler(unit, startDate, endDate, index, xRef.current?.offsetLeft, id)
        }}
        selected={selected}
      >
        {caption ??
          `${moment(startDate).format('YYYY-MM-DD')} - ${moment(endDate).format('YYYY-MM-DD')}`}
        {unit === Period.CUSTOM && selected && (
          <DeleteIcon
            onClick={() => deleteFilter(id)}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              top: '-10px',
              right: '-10px',
              width: 25,
            }}
          />
        )}
      </S.Card>
    </>
  )
}

export default TimePeriod
